import { Identifiable, CalendarHolidays } from "@planzone/dto";
import { Filter } from "@planzone/dto";

import { isFilteredByResources } from "./resources";

function isCalendarHolidaysFiltered(
  calendarHolidays: Identifiable<CalendarHolidays>,
  filter: Filter,
): boolean {
  return isFilteredByResources(calendarHolidays, filter);
}

export { isCalendarHolidaysFiltered };
